<template>
    <ac-modal :title="patient" ref="modal">
        <template>
            <div v-if="contracts.length == 0" class="row">
                <div class="col-md-12">
                    <p>This patient has no agreements</p>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-md-12">
                    <table class="table agreement-history-table">
                        <thead>
                        <tr>
                            <th scope="col">File</th>
                            <th scope="col">Signature Date</th>
                            <th scope="col">Download</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="contract in contracts" :key="contract.key">
                            <th scope="row">
                                <a v-if="contract.signed" href="#" @click.prevent="getContract(contract)">
                                    <i class="fa fa-file-pdf-o acressaRedText"></i>
                                    <span>{{ contract.fileName }}</span>
                                </a>
                                <span v-else>
                                    <i class="fa fa-file-pdf-o acressaRedText"></i>
                                    <span>{{ contract.fileName }}</span>
                                </span>
                            </th>
                            <td>
                                <span v-if="contract.signed">{{ contract.signatureDate | shortDate }}</span>
                            </td>
                            <td>
                                <a v-if="contract.signed" class="btn btn-blue btn-sm" href="#" @click.prevent="getContract(contract)">
                                    <span>DOWNLOAD</span>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {common} from "@/global/common.js";
    import _ from "lodash";

    export default {
        name: "PatientAgreementsDetails",
        props: {providerEntityId: {type: [Number], required: true}},
        data() {
            return {
                patient: '',
                contracts: []
            };
        },
        methods: {
            async showModal(info) {
                let [patient, signedContracts, unsignedContracts] = await Promise.all([
                    api.getDataWithTwoIds('Shared', this.providerEntityId, 'GetPatientBasicInfo', info.consumerId),
                    api.getDataWithTwoIds('ProviderContracts', this.providerEntityId, 'GetContractsByProvider', info.consumerId),
                    api.getDataWithTwoIds('ProviderContracts', this.providerEntityId, 'GetUnsignedContracts', info.consumerId)
                ]);
                this.patient = `${patient.firstName} ${patient.lastName}`;
                this.contracts = [
                    ...this.getSignedContracts(signedContracts),
                    ...this.getUnsignedContracts(unsignedContracts)
                ];

                this.$refs.modal.open();
            },
            getSignedContracts(contracts) {
                return contracts.map(contract => ({
                    key: `signed-${contract.consumerContractId}`,
                    fileName: contract.fileName,
                    signatureDate: contract.signatureDate,
                    consumerContractId: contract.consumerContractId,
                    signed: true
                }));
            },
            getUnsignedContracts(contracts) {
                return _(contracts)
                    .filter(contract => !contract.hasBeenSigned)
                    .uniqBy('providerFileId')
                    .map(contract => ({
                        key: `unsigned-${contract.providerFileId}`,
                        fileName: contract.contractName,
                        signatureDate: null,
                        consumerContractId: null,
                        signed: false
                    }))
                    .value();
            },
            async getContract(contract) {
                if (!contract.signed) return;

                return common.downloadFile(`ProviderContracts/${contract.consumerContractId}/ExportPatientAgreement`,
                    `${contract.fileName}.pdf`
                );
            },

        }
    }
</script>

<style scoped>
.agreement-history-table tbody tr {
    height: 50px;
}

.agreement-history-table tbody th,
.agreement-history-table tbody td {
    vertical-align: middle;
}
</style>